import styled from "../../../config/emotion";
import desktopLogin from "../../../assets/img/desktop-login.min.jpg";

export const LoginPageContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const LoginSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40%;

  @media only screen and (max-width: 1024px) {
    width: 100%;
  }
`;

export const DesktopSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 60%;
  height: 100vh;
  background-image: url(${desktopLogin});
  background-repeat: no-repeat;
  background-size: 100%;
  color: white;

  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;

export const Level1Header = styled.h1`
  font-size: 350%;
  margin: 20px;
  font-weight: bold;
`;

export const FlowioMessage = styled.p`
  font-size: 150%;
  font-style: italic;
  max-width: 80%;
  text-align: center;
`;
